import { FlexibleScope, OfferingMatrixData } from '../../../types/types'

// TODO shouldn't we use the actual matrix dimensions instead?
const matrixSize = 20

interface MatrixBoundaries {
  costSensitivityMax: number
  costSensitivityMin: number
  criticalityMax: number
  criticalityMin: number
}

function valueOrRangeBoundary(val: number, min: number, max: number): number {
  return Math.min(Math.max(val, min), max)
}

function relativeValInRange(val: number, min: number, max: number) {
  const offset = valueOrRangeBoundary(val, min, max) - min
  const delta = Math.max(max, 1) - min // TODO ensure not negative?
  return offset / delta
}

export interface CriticalityOrCostSensitivity {
  index: number
  max: number
  min: number
  value: number
}

interface CalculationResult {
  costSensitivity: CriticalityOrCostSensitivity
  criticality: CriticalityOrCostSensitivity
  scope: FlexibleScope
}

export function preferredOfferCalculation(
  offeringMatrixData: OfferingMatrixData,
  matrixBoundaries: MatrixBoundaries,
  criticality: number,
  costSensitivity: number
): CalculationResult {
  const { matrix, offering_mapping: offeringMapping } = offeringMatrixData

  const { criticalityMin, criticalityMax, costSensitivityMin, costSensitivityMax } = matrixBoundaries

  const scale = matrixSize - 1

  // convert criticality value to index between scale and 0
  // NOTE: lower index means more critical, i.e. price is higher
  const criticalityRelative = relativeValInRange(criticality, criticalityMin, criticalityMax)
  const criticalityIndex = scale - Math.floor(criticalityRelative * scale)

  // convert cost sensitivity value to index between 0 and scale
  // NOTE: higher index means less willingness to pay
  const costSensitivityRelative = relativeValInRange(costSensitivity, costSensitivityMin, costSensitivityMax)
  const costSensitivityIndex = Math.floor(costSensitivityRelative * scale)

  const offeringIndex = matrix[criticalityIndex][costSensitivityIndex]
  return {
    costSensitivity: {
      index: costSensitivityIndex,
      max: costSensitivityMax,
      min: costSensitivityMin,
      value: costSensitivity
    },
    criticality: {
      index: criticalityIndex,
      max: criticalityMax,
      min: criticalityMin,
      value: criticality
    },
    scope: offeringMapping[offeringIndex]
  }
}
